const headerSearchComponent = document.getElementById('header-search-component');
const $searchInput = $('.form-control.search-field');

let scrollDistance = 0;
let closeSize = 0;
var root = document.documentElement;
$('.js-main-search').on('click', () => {
  if ($('.header-search').hasClass('is-open')) return;

  if (closeSize == 0) {
    closeSize = $('.header-search .search-input .icon--close-mini-icon')[0].clientWidth;
    root.style.setProperty('--searchClose-width', closeSize + 16 + "px");
  }

  let headerHeight = $('header')[0].clientHeight.toString() + 'px';
  document.documentElement.style.setProperty('--header-height', headerHeight);
  headerSearchComponent.style.display = 'block';
  $('.wrapper-nav').addClass('menu-blocked');

  if (!window.isMobile()) {
    document.querySelectorAll('.blur-body-overlay')[0].classList.add('active');
  }
  $('.header-search').addClass('is-open');
  $('.header-search').removeClass('is-closed');
  $('body').trigger('search:open');
  scrollDistance = window.pageYOffset;
  $('body')[0].setAttribute("style", "overflow-y: hidden;position:fixed;top: -"+ scrollDistance +"px;")
  const minicart = document.querySelector('.layer-minicart');
  minicart.dataset.lastoffset = scrollDistance;

  if ($('.header-search .einstein-carousel').length == 0) {
    $('.header-search').addClass('no-recommender-available');
  }

  //$searchInput.trigger('focus');

  lockNavigationOnSearch();

  var height = $('.suggestions-wrapper')[0].clientHeight;
  var total = height + 70;
  document.documentElement.style.setProperty('--min-rec-height', total.toString() + 'px');
  window.dispatchEvent(new Event('resize'));

  $('.suggestions-wrapper').addClass('animation');
});

$('#search-bar-close').on('click', () => {
  $searchInput.trigger('focus');
  
  //DISMISS FOCUS TRAP ON SEARCH MODAL FOR VOICE OVER
  unlockNavigationOnSearch();

  $('.suggestions-wrapper').addClass('animation');
  $('.wrapper-nav').removeClass('menu-blocked');
  if (window.isMobile()) {
    $('header').removeClass('header-unpin');
  }
  $('.header-search').removeClass('is-open');

  $('#search-bar-close').attr('aria-hidden', 'true');

  //RESET SEARCH INPUT FOR VOICE-OVER RECOGNITION
  $searchInput.removeAttr('data-np-checked');
  $searchInput.attr('aria-expanded', 'false');
  $searchInput.attr('aria-activedescendant', '');
  
  $searchInput.attr('role', 'searchbox'); 
  
  $searchInput.trigger('blur');

  setTimeout(function() {
      $searchInput.attr('role', 'combobox');
      $searchInput.trigger('focus'); 
  }, 100);

  $('.header-search').addClass('is-closed');

  // $('body')[0].style.overflow = 'visible';
  $('body')[0].style['overflow-y'] = 'visible';
  $('body')[0].style['position'] = 'unset';
  $('body')[0].style['top'] = '0';
  const minicart = document.querySelector('.layer-minicart').dataset.lastoffset;

  // // Set the window's scroll position back to what it was before the modal was opened
  window.scrollTo(0, scrollDistance);

  setTimeout(function() {
    if (!window.isMobile()) {
      document.querySelectorAll('.blur-body-overlay')[0].classList.remove('active');
    }
    $('.header-search').removeClass('is-closed');
    $('.suggestions-wrapper').removeClass('animation');
  }, 500);

  // setTimeout(function() {
  //   headerSearchComponent.style.display = 'none';
  // }, 1000);
  $('.js-main-search').trigger('focus');  
});

$('.header-search .form-control.search-field').on('click', () => {
  if (window.isMobile() && !$('.header-search').hasClass('is-open')) {
  
    //KEEP FOCUS TRAP ON SEARCH MODAL FOR VOICE OVER
    lockNavigationOnSearch();

    $('.suggestions-wrapper').addClass('animation');
    if (closeSize == 0) {
      closeSize = $('.header-search .search-input .icon--close-mini-icon')[0].clientWidth;
      root.style.setProperty('--searchClose-width', closeSize + 16 + "px");
    }
    let headerHeight = $('header')[0].clientHeight.toString() + 'px';
    document.documentElement.style.setProperty('--header-height', headerHeight);
    headerSearchComponent.style.display = 'block';
    $('.wrapper-nav').addClass('menu-blocked');
    if (!window.isMobile()) {
      document.querySelectorAll('.blur-body-overlay')[0].classList.add('active');
    }

    !window.isMobile() ? $searchInput.trigger('focus') : '';

    if (window.isMobile()) {
      $('header').addClass('header-unpin');
    }

    $('.header-search').addClass('is-open');
    $('.header-search').removeClass('is-closed');
    $('body').trigger('search:open');
    scrollDistance = window.pageYOffset;

    //COMMENT THIS LINE TO PREVENT LOOP VIBRATION ON MOBILE WITH VOICE OVER
    //$('body')[0].setAttribute("style", "overflow-y: hidden;position:fixed;top: -"+ scrollDistance +"px;")

    const minicart = document.querySelector('.layer-minicart');
    minicart.dataset.lastoffset = scrollDistance;
    if ($('.header-search .einstein-carousel').length == 0) {
      $('.header-search').addClass('no-recommender-available');
    }
    var height = $('.suggestions-wrapper')[0].clientHeight;
    var total = height + 70;
    document.documentElement.style.setProperty('--min-rec-height', total.toString() + 'px');
    window.dispatchEvent(new Event('resize'));
  }
});

if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', () => {
    if (window.visualViewport.height >= window.innerHeight) {
      const $modalSearch = $('#header-search-component');
      if ($modalSearch.hasClass('is-open') && document.activeElement !== $searchInput[0]) {
        $searchInput.trigger('focus');
      }
    }
  });
}

function lockNavigationOnSearch() {
  $('#search-bar-close').attr('aria-hidden', 'false');
  $('.header-search').attr('role', 'dialog').attr('aria-modal', 'true');
  $('body > *').not('.header-search').attr('aria-hidden', 'true');
}

function unlockNavigationOnSearch() {
  var $searchContainer = $('.header-search');
  
  $searchContainer.removeAttr('role');
  $searchContainer.removeAttr('aria-modal');
  
  $('body > *').not('.header-search').removeAttr('aria-hidden');
}

const $toolkit = $('#DW-SFToolkit');

if ($toolkit.length) {
    $toolkit.attr({
        'aria-hidden': 'true',
        'tabindex': '-1'
    });
}